import { useContext, useEffect, useState } from 'react'
import PremiumHeader from '../components/PremiumHeader'
import { Subscription } from '../components/Subscription'
import useAxiosRequests from '../hooks/useAxiosRequest'
import imageHand from '../img/image-subscription-1.png'
import imagePeople from '../img/image-subscription-2png.png'
import ExternalRoutes from '../config/ExternalRoutes'
import { MessageContext } from '../context/MessageContext'
import { useNavigate } from 'react-router'
import AuthContext from '../context/AuthContext'

export const SubscriptionList = () => {
  const { sendRequest } = useAxiosRequests()
  const [subscriptions, setSubscriptions] = useState([])
  const { showError } = useContext(MessageContext)
  const { userSubscribe } = useContext(AuthContext);
  const [selected, setSelected] = useState('')
  const [isLoading, setIsLoading] = useState(true);

  const fecthData = async () => {
    try {
      const response = await sendRequest({
        method: 'GET',
        url: ExternalRoutes.subscription.list,
      });
      if (response) {
        setSubscriptions(response.member);
      }

    } catch (error) {
      showError(error.message)
    } finally {
      setIsLoading(false);
    }
  }




  useEffect(() => {
    fecthData();
  }, []);


  const handleRadioChange = index => {
    setSelected(index)
  }

  const navigate = useNavigate()
  const handleSubmint = async (e) => {
    e.preventDefault();

    const selectedData = subscriptions[selected];
    navigate('/payment-method', { state: { subscription: selectedData } });
  }


  return (
    <>
      <section className='kl-subsription-content'>
        <div className=''>
          <PremiumHeader />
          <div className='kl-image-subscribes-one'>
            <img src={imageHand} alt='subsription' />
          </div>
          <div className='kl-subscribe-title'>
            <h2>Choisissez le forfait idéal pour vos besoins</h2>
          </div>
          <div className='kl-image-subscribe-two'>
            <img src={imagePeople} alt='subsription' />
          </div>
          <div className='kl-text-subscription'>
            <p>
              Commencer votre essai gratuit de 30 jours, annulez à tout moment !
            </p>
          </div>
        </div>
      </section>
      <section>
        <div className=''>
          <div>
            {subscriptions.length > 0 ? (
              <form noValidate onSubmit={handleSubmint}>
                <div className='kl-subscription-list'>
                  {subscriptions.map((data, index) => {
                    const isSelected = selected === index;
                    const isChecked = data?.id === userSubscribe?.conSubscriptionId?.id ? true : false;

                    return (
                      <label
                        className={`subscription-wrapper`}
                        style={{ display: 'block', cursor: 'pointer' }}
                        key={index}
                      >
                        <input
                          type='radio'
                          name='subscription'
                          checked={isSelected}
                          onChange={() => handleRadioChange(index)}
                          style={{ marginBottom: '10px' }}
                          className='kl-none'
                          disabled={isChecked}
                        />
                        <Subscription
                          data={data?.subPrice}
                          isSelected={isSelected}
                          isDisabled={isChecked}
                        />
                      </label>
                    )
                  })}
                </div>
                <div className='kl-button-subscription-content'>
                  <div className='kl-button-start-sub'>
                    <button
                      type='submit'
                      disabled={selected === '' || isLoading}
                    >
                      Commencer
                    </button>
                  </div>
                </div>
              </form>
            ) : (
              <div>Nothing data</div>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
